module.exports = __webpack_public_path__ + "static/img/Mary.e5f4ba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/photos/testimonials/crs/Mary.png
// module id = Il10
// module chunks = 0